import { API_BASE_URL } from './constants';

export const getMediaUrl = (url) => {
    if (!url) return null;

    // Handle external or data URLs
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
        return url;
    }

    // API_BASE_URL is 'https://yc.churchsocial.us/api'
    // We want the base domain: 'https://yc.churchsocial.us'
    const baseUrl = API_BASE_URL.replace(/\/api\/?$/, '');

    // Ensure relationship between /api/uploads and final URL
    // If url starts with /api/uploads, it will result in https://yc.churchsocial.us/api/uploads/...
    // If url starts with /uploads, it will result in https://yc.churchsocial.us/uploads/...
    const relativeUrl = url.startsWith('/') ? url : `/${url}`;

    return `${baseUrl}${relativeUrl}`;
};
